export const TOKEN = 'TOKEN'
export const REAlNAME = 'REAlNAME'
export const ORGNAME = 'ORGNAME'
export const EMPLOYEEID = 'EMPLOYEEID'
export const ORGCODE = 'ORGCODE'
